
import { FileText, MapPin, MessageSquare, Search, User } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

const BottomTabBar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    { id: 'explore', label: 'Explorar', icon: Search, path: '/categorias' },
    { id: 'nearby', label: 'Na zona', icon: MapPin, path: '/nearby-search' },
    { id: 'messages', label: 'Mensagens', icon: MessageSquare, path: '/messages' },
    { id: 'atividade', label: 'Atividade', icon: FileText, path: '/atividade' },
    { id: 'profile', label: 'Perfil', icon: User, path: '/profile' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
      <div className="flex justify-around items-center py-2 px-4">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const active = isActive(tab.path);
          
          return (
            <button
              key={tab.id}
              onClick={() => navigate(tab.path)}
              className={`flex flex-col items-center justify-center p-2 rounded-lg transition-colors ${
                active 
                  ? 'text-orange-600 bg-orange-50' 
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              <Icon className={`w-5 h-5 mb-1 ${active ? 'text-orange-600' : ''}`} />
              <span className={`text-xs font-medium ${active ? 'text-orange-600' : ''}`}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BottomTabBar;
